import React from 'react'
import { PageHeader, BankaRaporForm } from '../components/bankaRapor'
import { Col, Space } from 'antd'

export default function BankaRapor() {
    return (
        <>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <PageHeader />
                <Col xxl={8} xl={12} lg={24} md={24} sm={24} xs={24}>
                    <BankaRaporForm />
                </Col>
            </Space>
        </>
    )
}
